import client from "./client";

const getTopMerchant = () => client.get("metric/top/merchants?type=value");

export default {getTopMerchant}; 
